import { render, staticRenderFns } from "./v_Email_Review.vue?vue&type=template&id=8c4b42ec&scoped=true&"
import script from "./v_Email_Review.vue?vue&type=script&lang=js&"
export * from "./v_Email_Review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4b42ec",
  null
  
)

export default component.exports